import { LabelType } from '@piccolohealth/pbs-common';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormStack } from '../../components/forms/FormStack';
import { HookedFormField } from '../../components/forms/HookedFormField';
import { HookedInput } from '../../components/forms/HookedInput';
import { HookedLabelChooser } from '../../components/forms/HookedLabelChooser';
import { HookedSingleDatepicker } from '../../components/forms/HookedSingleDatepicker';
import { HookedSwitch } from '../../components/forms/HookedSwitch';
import { HookedTaskRecurrenceSelect } from '../../components/forms/HookedTaskRecurrenceSelect';
import { HookedUserMultiChooser } from '../../components/forms/HookedUserMultiChooser';

interface Props {
  participantId: string;
}

export const ParticipantTaskForm = (props: Props) => {
  const { participantId } = props;
  const { watch } = useFormContext();
  const requiresDueDate = watch('requiresDueDate');

  return (
    <FormStack>
      <HookedFormField
        name='name'
        label='Task name'
        helperText='What should this task be called?'
        required
      >
        <HookedInput name='name' size='sm' placeholder='Enter task name' />
      </HookedFormField>
      <HookedFormField
        name='requiresDueDate'
        label='Requires due date'
        helperText='Will this task be marked as requiring a due date?'
      >
        <HookedSwitch name='requiresDueDate' />
      </HookedFormField>
      {requiresDueDate && (
        <HookedFormField
          name='dueDate'
          label='Due date'
          helperText='When is this task due?'
          required
        >
          <HookedSingleDatepicker name='dueDate' size='sm' placeholder='Choose a due date' />
        </HookedFormField>
      )}
      <HookedFormField
        name='recurrence'
        label='Recurrence interval'
        helperText='Once the task is completed, should a new task be created and at what interval?'
      >
        <HookedTaskRecurrenceSelect name='recurrence' />
      </HookedFormField>
      <HookedFormField
        name='assigneeIds'
        label='Assignees'
        helperText='Who should be notified for this task?'
      >
        <HookedUserMultiChooser
          name='assigneeIds'
          participantId={participantId}
          size='sm'
          placeholder='Choose one or more assignees'
        />
      </HookedFormField>
      <HookedFormField name='labelIds' label='Labels'>
        <HookedLabelChooser name='labelIds' type={LabelType.ParticipantTask} />
      </HookedFormField>
    </FormStack>
  );
};
